import { TFunction } from "i18next";
import { BaseChatDtoCourse } from "../api/madlenAPI.schemas";
import { SelectOption } from "@core/multi-select";

export const LessonPlanGradeOptions = (t: TFunction): SelectOption[] => [
  {
    value: "1",
    label: "1",
  },
  {
    value: "2",
    label: "2",
  },
  {
    value: "3",
    label: "3",
  },
  {
    value: "4",
    label: "4",
  },
  {
    value: "5",
    label: "5",
  },
  {
    value: "6",
    label: "6",
  },
  {
    value: "7",
    label: "7",
  },
  {
    value: "8",
    label: "8",
  },
  {
    value: "-4",
    label: t("grade.preparatory"),
  },
  {
    value: "9",
    label: "9",
  },
  {
    value: "10",
    label: "10",
  },
  {
    value: "11",
    label: "11",
  },
  {
    value: "12",
    label: "12",
  },
];

export const GradeOptions = (t: TFunction): SelectOption[] => [
  {
    value: "-3",
    label: t("grade.3_4_age"),
  },
  {
    value: "-2",
    label: t("grade.4_5_age"),
  },
  {
    value: "1",
    label: "1",
  },
  {
    value: "2",
    label: "2",
  },
  {
    value: "3",
    label: "3",
  },
  {
    value: "4",
    label: "4",
  },
  {
    value: "5",
    label: "5",
  },
  {
    value: "6",
    label: "6",
  },
  {
    value: "7",
    label: "7",
  },
  {
    value: "8",
    label: "8",
  },
  {
    value: "-4",
    label: t("grade.preparatory"),
  },
  {
    value: "9",
    label: "9",
  },
  {
    value: "10",
    label: "10",
  },
  {
    value: "11",
    label: "11",
  },
  {
    value: "12",
    label: "12",
  },
];

export const isApCourse = (course: string) => {
  return course.startsWith("AP_");
};

export const isIgcseCourse = (course: string) => {
  return course.startsWith("IGCSE_");
};

export const isIbCourse = (course: string) => {
  return course.startsWith("IB_");
};

export const isAlevelCourse = (course: string) => {
  return course.startsWith("ALEVEL_");
};

export const isTurkishCourse = (course: string) => {
  return (
    !isAlevelCourse(course) &&
    !isIgcseCourse(course) &&
    !isIbCourse(course) &&
    !isApCourse(course)
  );
};

export const CourseData: {
  [key in BaseChatDtoCourse]: {
    name: (grade: number) => string;
    color?: string;
    backgroundColor?: string;
    visible: (grade: number) => boolean;
    borderColor?: string;
    emoji?: string;
    textColor?: string;
    hasOutcomes: boolean;
    hasMaarifOutcomes: boolean;
  };
} = {
  HISTORY: {
    name: (grade: number) => {
      if (grade === 3 || grade === 2 || grade === 1) return "LIFE_KNOWLEDGE";
      if (grade === 4 || grade === 5 || grade === 6 || grade === 7)
        return "SOCIAL";
      if (grade === 8 || grade === 12) return "REVOLUTION_AND_HISTORY";
      if (grade === -4 || grade === 9 || grade === 10 || grade === 11)
        return "HISTORY";
      return "REVOLUTION";
    },
    visible: (grade: number) => grade !== -1 && grade !== -2 && grade !== -3,
    hasOutcomes: true,
    hasMaarifOutcomes: true,
  },
  TURKISH: {
    name: (grade: number) =>
      grade < 9 && grade !== -4 ? "TURKISH" : "TURKISH_LITERATURE",
    visible: (grade: number) => grade !== -1 && grade !== -2 && grade !== -3,
    hasOutcomes: true,
    hasMaarifOutcomes: true,
  },
  SCIENCE: {
    name: () => "SCIENCE",
    visible: (grade: number) =>
      grade < 9 && grade > 2 && grade !== -1 && grade !== -2 && grade !== -3,
    hasOutcomes: true,
    hasMaarifOutcomes: true,
  },
  GEOGRAPHY: {
    name: () => "GEOGRAPHY",
    visible: (grade: number) => grade > 8 || grade === -4,
    hasOutcomes: true,
    hasMaarifOutcomes: true,
  },
  CHEMISTRY: {
    name: () => "CHEMISTRY",
    visible: (grade: number) => grade > 8 || grade === -4,
    hasOutcomes: true,
    hasMaarifOutcomes: true,
  },
  PHYSICS: {
    name: () => "PHYSICS",
    visible: (grade: number) => grade > 8 || grade === -4,
    hasOutcomes: true,
    hasMaarifOutcomes: true,
  },
  MATHEMATICS: {
    name: () => "MATHEMATICS",
    visible: (grade: number) => grade !== -1 && grade !== -2 && grade !== -3,
    hasOutcomes: true,
    hasMaarifOutcomes: true,
  },
  BIOLOGY: {
    name: () => "BIOLOGY",
    visible: (grade: number) => grade > 8 || grade === -4,
    hasOutcomes: true,
    hasMaarifOutcomes: true,
  },
  DIGITAL_CITIZENSHIP: {
    name: () => "DIGITAL_CITIZENSHIP",
    visible: (grade: number) => grade >= 6 || grade === -4,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  PHILOSOPHY: {
    name: () => "PHILOSOPHY",
    visible: (grade: number) => grade === 10 || grade === 11,
    hasOutcomes: true,
    hasMaarifOutcomes: true,
  },
  MONTH_36_48: {
    name: () => "MONTH_36_48",
    visible: (grade: number) => grade === -3,
    hasOutcomes: false,
    hasMaarifOutcomes: true,
  },
  MONTH_48_60: {
    name: () => "MONTH_48_60",
    visible: (grade: number) => grade === -2,
    hasOutcomes: false,
    hasMaarifOutcomes: true,
  },
  RELIGION: {
    name: () => "RELIGION",
    visible: () => false,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  ENGLISH: {
    name: () => "ENGLISH",
    visible: (grade: number) => grade >= 2 && grade <= 8,
    hasOutcomes: false,
    hasMaarifOutcomes: true,
  },
  // New AP_2025 courses
  AP_2025_BIOLOGY: {
    name: () => "AP_2025_BIOLOGY",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  AP_2025_CALCULUS_AB_AND_BC: {
    name: () => "AP_2025_CALCULUS_AB_AND_BC",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  AP_2025_CHEMISTRY: {
    name: () => "AP_2025_CHEMISTRY",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS: {
    name: () => "AP_2025_COMPARATIVE_GOVERNMENT_AND_POLITICS",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  AP_2025_COMPUTER_SCIENCE_A: {
    name: () => "AP_2025_COMPUTER_SCIENCE_A",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  AP_2025_COMPUTER_SCIENCE_PRINCIPLES: {
    name: () => "AP_2025_COMPUTER_SCIENCE_PRINCIPLES",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  AP_2025_ENVIRONMENTAL_SCIENCE: {
    name: () => "AP_2025_ENVIRONMENTAL_SCIENCE",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  AP_2025_EUROPEAN_HISTORY: {
    name: () => "AP_2025_EUROPEAN_HISTORY",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  AP_2025_HUMAN_GEOGRAPHY: {
    name: () => "AP_2025_HUMAN_GEOGRAPHY",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  AP_2025_MACROECONOMICS: {
    name: () => "AP_2025_MACROECONOMICS",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  AP_2025_MICROECONOMICS: {
    name: () => "AP_2025_MICROECONOMICS",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  AP_2025_PHYSICS_1: {
    name: () => "AP_2025_PHYSICS_1",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  AP_2025_PHYSICS_2: {
    name: () => "AP_2025_PHYSICS_2",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM: {
    name: () => "AP_2025_PHYSICS_C_ELECTRICITY_AND_MAGNETISM",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  AP_2025_PHYSICS_C_MECHANICS: {
    name: () => "AP_2025_PHYSICS_C_MECHANICS",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  AP_2025_PRECALCULUS: {
    name: () => "AP_2025_PRECALCULUS",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  AP_2025_PSYCHOLOGY: {
    name: () => "AP_2025_PSYCHOLOGY",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  AP_2025_STATISTICS: {
    name: () => "AP_2025_STATISTICS",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  AP_2025_WORLD_HISTORY_MODERN: {
    name: () => "AP_2025_WORLD_HISTORY_MODERN",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  UNKNOWN: {
    name: () => "UNKNOWN",
    visible: () => false,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  IGCSE_BIOLOGY: {
    name: () => "IGCSE_BIOLOGY",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  IGCSE_PHYSICS: {
    name: () => "IGCSE_PHYSICS",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  IGCSE_CHEMISTRY: {
    name: () => "IGCSE_CHEMISTRY",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  IGCSE_BUSINESS_STUDIES: {
    name: () => "IGCSE_BUSINESS_STUDIES",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  IGCSE_ECONOMICS: {
    name: () => "IGCSE_ECONOMICS",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  IGCSE_COMPUTER_SCIENCE: {
    name: () => "IGCSE_COMPUTER_SCIENCE",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  IGCSE_GEOGRAPHY: {
    name: () => "IGCSE_GEOGRAPHY",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  IGCSE_HISTORY: {
    name: () => "IGCSE_HISTORY",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  IGCSE_MATHEMATICS: {
    name: () => "IGCSE_MATHEMATICS",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  IB_DP_GEOGRAPHY: {
    name: () => "IB_DP_GEOGRAPHY",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  IB_DP_BUSINESS_MANAGEMENT: {
    name: () => "IB_DP_BUSINESS_MANAGEMENT",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  IB_DP_CHEMISTRY: {
    name: () => "IB_DP_CHEMISTRY",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  IB_DP_BIOLOGY: {
    name: () => "IB_DP_BIOLOGY",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  IB_DP_ECONOMICS: {
    name: () => "IB_DP_ECONOMICS",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  IB_DP_HISTORY: {
    name: () => "IB_DP_HISTORY",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  IB_DP_PHYSICS: {
    name: () => "IB_DP_PHYSICS",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  IB_DP_COMPUTER_SCIENCE: {
    name: () => "IB_DP_COMPUTER_SCIENCE",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  IB_DP_MATHEMATICS: {
    name: () => "IB_DP_MATHEMATICS",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  ALEVEL_BIOLOGY: {
    name: () => "ALEVEL_BIOLOGY",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  ALEVEL_BUSSINESS: {
    name: () => "ALEVEL_BUSSINESS",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  ALEVEL_CHEMISTRY: {
    name: () => "ALEVEL_CHEMISTRY",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  ALEVEL_COMPUTER_SCIENCE: {
    name: () => "ALEVEL_COMPUTER_SCIENCE",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  ALEVEL_ECONOMICS: {
    name: () => "ALEVEL_ECONOMICS",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  ALEVEL_EUROPEAN_HISTORY: {
    name: () => "ALEVEL_EUROPEAN_HISTORY",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  ALEVEL_FURTHER_MATHEMATICS: {
    name: () => "ALEVEL_FURTHER_MATHEMATICS",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  ALEVEL_GEOGRAPHY: {
    name: () => "ALEVEL_GEOGRAPHY",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  ALEVEL_INTERNATIONAL_HISTORY: {
    name: () => "ALEVEL_INTERNATIONAL_HISTORY",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  ALEVEL_MATHEMATICS: {
    name: () => "ALEVEL_MATHEMATICS",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  ALEVEL_PHYSICS: {
    name: () => "ALEVEL_PHYSICS",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  ALEVEL_SOCIOLOGY: {
    name: () => "ALEVEL_SOCIOLOGY",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  ALEVEL_US_HISTORY_SINCE_1877: {
    name: () => "ALEVEL_US_HISTORY_SINCE_1877",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
  ALEVEL_US_HISTORY_TO_1877: {
    name: () => "ALEVEL_US_HISTORY_TO_1877",
    visible: (grade: number) => grade !== -1,
    hasOutcomes: false,
    hasMaarifOutcomes: false,
  },
};
